import App from "./vue/App.vue";
import router from "./vue/router";
import store from "./vue/store";
import i18n from "./vue/lang/i18n";
import moment from "moment";

import {
  RESET_PASSWORD_STEP,
  SET_WSS_CONNECTION,
  SUBSCRIBE_TO_REPORT_CHANNEL,
  SYNC_EXPORTS,
  INITIALIZE_AUTH
} from "@vue-app/store/const/actions-types";

import { VueReCaptcha } from 'vue-recaptcha-v3';
const RECAPTCHA_SITE_KEY = import.meta.env.VITE_RECAPTCHA_SITE_KEY;

import {
    createApp,
    initializeBaseVuePluginsAndDirectives,
    initWssConnection,
    injectVueGlobals,
    subscribeToWssChannels,
  } from "@js-app/bootstrap-helpers";
  import authorizer from '@js-app/services/helpers/authorizer-instance'

(async function () {
  await createApp(App, {
    el: "#app",
    router,
    store,
    i18n,
    beforeAppCreated: async (app) => {
      let recaptchaInitialized = false;

      router.beforeEach((to, from, next) => {
        if (!recaptchaInitialized && RECAPTCHA_SITE_KEY && to.name === 'login') {
          app.use(VueReCaptcha, {
            siteKey: RECAPTCHA_SITE_KEY,
          });
          recaptchaInitialized = true;
        }
        next();
      });

      await store.dispatch(INITIALIZE_AUTH);
      await initializeBaseVuePluginsAndDirectives(app);
      await injectVueGlobals(app, { moment, authorizer });
    },
    afterAppCreated: async () => {
      await bootstrap();
      if (store.getters.isUserLoggedIn) {
        await initWssConnection(store, SET_WSS_CONNECTION, () =>
            subscribeToWssChannels(
                store,
                SUBSCRIBE_TO_REPORT_CHANNEL,
                store.getters.userData.report_channel
            )
        );
      }
    },
  });
})();

async function bootstrap() {
  if (store.getters.isUserLoggedIn) {
    await store.dispatch(SYNC_EXPORTS);
  }

  try {
    await store.dispatch(
        RESET_PASSWORD_STEP,
        JSON.parse(localStorage.getItem("resetPasswordData") || "{}")
    );
  } catch (e) {}
}
